module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"clearSelection":"Clear selection","close":"Close","goToToday":"Go to today","selectDecade":"Select Decade","selectMonth":"Select Month","selectYear":"Select Year","selectTime":"Select time"},"no":{"clearSelection":"Tøm valg","close":"Lukk","goToToday":"Gå til i dag","selectDecade":"Velg Tiår","selectMonth":"Velg Måned","selectYear":"Velg År","selectTime":"Velg tid"}}')
  delete Component.options._Ctor
}
